import React, { useRef } from 'react'
import styles from './Comparison.module.scss'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const Comparison: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.comparison} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inner}>
        <h2 className={styles.comparison__title}>比較表</h2>
        <div className={styles.comparison__table__wrapper}>
          <div className={styles.comparison__table__wrapper__item}>
            <h3 className={styles.comparison__subTitle}>他のSaaSサービスとの比較</h3>
            <table className={styles.comparison__table}>
              <tr>
                <th>&nbsp;</th>
                <th>ZEBRA</th>
                <th>他社サービス</th>
              </tr>
              <tbody>
                <tr>
                  <th>目的</th>
                  <td>プッシュ通知専用</td>
                  <td>MAツール</td>
                </tr>
                <tr>
                  <th>配信</th>
                  <td>顧客属性DBを利用し、セグメント・リスト配信が可能</td>
                  <td>イベントやユーザープロフィールに基づくセグメント配信が可能</td>
                </tr>
                <tr>
                  <th>機能性</th>
                  <td>最適化</td>
                  <td>高機能</td>
                </tr>
                <tr>
                  <th>操作性</th>
                  <td>直感的</td>
                  <td>学習コストが必要</td>
                </tr>
                <tr>
                  <th>コスト</th>
                  <td>低</td>
                  <td>高</td>
                </tr>
                <tr>
                  <th>カスタマイズ</th>
                  <td>可</td>
                  <td>不可</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className={styles.comparison__table__wrapper__item}>
            <h3 className={styles.comparison__subTitle}>開発した場合との比較</h3>
            <table className={styles.comparison__table}>
              <tr>
                <th>&nbsp;</th>
                <th>ZEBRA</th>
                <th>スクラッチ開発</th>
              </tr>
              <tbody>
                <tr>
                  <th>コスト</th>
                  <td>低</td>
                  <td>高</td>
                </tr>
                <tr>
                  <th>導入までの期間</th>
                  <td>短期間</td>
                  <td>長期間</td>
                </tr>
                <tr>
                  <th>機能性</th>
                  <td>最適化</td>
                  <td>自由（要設計）</td>
                </tr>
                <tr>
                  <th>運用・保守</th>
                  <td>サービス内で継続的にサポート</td>
                  <td>別途保守契約</td>
                </tr>
                <tr>
                  <th>信頼性・拡張性</th>
                  <td>スケールや安定稼働が保証されている</td>
                  <td>自社の環境次第</td>
                </tr>
                <tr>
                  <th>セキュリティ</th>
                  <td>万全</td>
                  <td>自社で担保</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  )
}
export default Comparison
